import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children }) => (
  <p className="font-mono-label text-xs uppercase tracking-[0.3em] text-[#E6C594]/90 font-semibold flex items-center gap-3">
    <span className="inline-block h-px w-8 bg-[#E6C594]/60" />
    {children}
  </p>
);
